<div class="LesitungEdit row" *ngIf="Entry && Entry != null">
  <div class="row">
    <div class="row">
      <div class="col edit">
        <AdminCard [Item]="Entry">
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="name" [(ngModel)]="Entry.name">
                <label for="name">Name</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="ansprechPartner" [(ngModel)]="Entry.ansprechPartner">
                <label for="ansprechPartner">Ansprechpartner</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="mail" [(ngModel)]="Entry.mail">
                <label for="mail">E-Mail</label>
              </div>
            </div>
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="telefone" [(ngModel)]="Entry.telefone">
                <label for="telefone">Telefone</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="apiUrl" [(ngModel)]="Entry.apiUrl">
                <label for="apiUrl">Api Url</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="input-group mb-3">
                <div class="form-floating">
                  <input type="number" class="form-control" step="0.01" min="0.01" id="leitstellenKostenMonatBrutto" placeholder="0.00" [(ngModel)]="Entry.leitstellenKostenMonatBrutto">
                  <label for="leitstellenKostenMonatBrutto">Kosten im Monat (Brutto)</label>
                </div>
                <span class="input-group-text" id="basic-addon2">€</span>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="input-group mb-3">
              <div class="form-floating">
                <input type="number" class="form-control" step="0.01" min="0.01" id="leitstellenKostenMonatNetto" placeholder="0.00" [(ngModel)]="Entry.leitstellenKostenMonatNetto">
                <label for="leitstellenKostenMonatNetto">Kosten im Monat (Netto)</label>
              </div>
              <span class="input-group-text" id="basic-addon2">€</span>
            </div>
          </div>
          <Address [(address)]="Entry.adresse"></Address>
        </AdminCard>
      </div>
    </div>
  </div>
</div>
<div class="row Button">
  <div class="col"></div>
  <div class="col-auto">
    <div class="btn btn-success" (click)="SaveData()">Speichern</div>
  </div>
</div>
<ng-template #successTpl> Speichern erfolgreich! </ng-template>
